import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from 'src/app/auth.service';
import { ChangePasswordService } from 'src/app/change-password.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})

export class ResetPasswordComponent {
  id: number = 0;
  code: string = '';

  confirmPassword: string = '';
  newPassword: string = '';
  confirmNewPassword: string = '';
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  isLoading: boolean = false;
  isSuccess: boolean = false;
  message: string = '';
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private changePasswordService: ChangePasswordService,
    private snackBar: MatSnackBar,// Inject MatSnackBar service
    private navigationRouter: Router // Inject Router service
    
  ) {}
  ngOnInit(): void {
    this.id = +this.route.snapshot.paramMap.get('id') || 0;
    this.code = this.route.snapshot.queryParamMap.get('Code') || '';

    console.log('ID:', this.id);  // Output: 2
    console.log('Code:', this.code);  // Output: RXZpZGFudERUUjIwMjQ=
  }
  private readonly MIN_PASSWORD_LENGTH = 8;


  // Validate if new password and confirm new password match
  get passwordsMatch(): boolean {
    return this.newPassword === this.confirmNewPassword;
  }

  // Validate if the new password meets the minimum length
  get isPasswordValid(): boolean {
    return this.newPassword.length >= this.MIN_PASSWORD_LENGTH;
  }
  // Toggles visibility for the new password
  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  // Toggles visibility for the confirm password
  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  // Handles form submission
  async onSubmit(passwordForm: NgForm) {
    // Check if passwords match
    if (!this.passwordsMatch) {
      this.message = 'New Password and Confirm New Password do not match!';
      this.isSuccess = false;
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
      return;
    }
  
    // Check if password meets minimum length
    if (!this.isPasswordValid) {
      this.message = `Password must be at least ${this.MIN_PASSWORD_LENGTH} characters long.`;
      this.isSuccess = false;
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
      return;
    }
  
  
  
    // Show loading indicator
    this.isLoading = true;
    this.message = '';
  
    try {
      // Call the change password service asynchronously
      const response = await this.changePasswordService.resetPassword(
        this.id,
        this.code,
        this.newPassword
      );
  
      // Handle success
      this.isSuccess = true;
      this.message = response.message || 'Password changed successfully!';
      this.showSnackBar(this.message, 'success'); // Show snackbar on success
  
      // Clear the fields after successful change
  
      this.newPassword = '';
      this.confirmNewPassword = '';
  
      // Mark form controls as untouched after clearing the fields
      passwordForm.resetForm();
      localStorage.removeItem('userData');
      localStorage.removeItem('userOrgData'); 
      localStorage.removeItem('userOrgs');
      localStorage.removeItem('selectedOrganizationId');
      localStorage.removeItem('selectedOrganizationName');
      // Navigate to login page
    // this.navigationRouter.navigate(['/login']); //redirect to the login page
     this.navigationRouter.navigate(['/login']).then(() => {
      window.location.reload();
    });
    } catch (error) {
      // Handle error
      this.isSuccess = false;
      this.message =
        error.error?.message || 'An error occurred while changing the password.';
      this.showSnackBar(this.message, 'error'); // Show snackbar on failure
    } finally {
      // Hide loading indicator
      this.isLoading = false;
    }
  }
   // Method to display the snackbar message
   private showSnackBar(message: string, type: 'success' | 'error'): void {
    const snackBarClass = type === 'success' ? 'snack-success' : 'snack-error';
    this.snackBar.open(message, 'Close', {
      duration: 5000, // Duration in milliseconds
      panelClass: [snackBarClass], // Apply custom class based on message type
    });
  }

}
